// src/pages/books/CreateBook.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { BookType } from "../../../types/Library";
import { createBook, updateBook } from "../../../services/library/book";
import { routes } from "../../../routes";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { BookFormValidation } from "./BookFormValidation";
import toast from "react-hot-toast";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { useGetCategoriesQuery } from "../../../hooks/library/useGetCategoriesQuery";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useAppDispatch } from "../../../hooks/hooks";
import { resetBookData } from "../../../redux/slices/library/book";

export const UpdateBook = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const mutation = useMutation({ mutationFn: updateBook, mutationKey: "updateBook" });
    const { data, isLoading, isError } = useGetCategoriesQuery({ PageNumber: 1, PageSize: 400 });
    const bookFormData = useSelector((state: RootState) => state.book);

    const defaultValues: BookType = bookFormData;

    const { control, handleSubmit, formState: { errors } } = useForm<BookType>({
        resolver: yupResolver(BookFormValidation),
        defaultValues,
        mode: "onBlur",
    });

    const onSubmit = handleSubmit(async (data) => {
        try {
            await mutation.mutateAsync(data);
            toast.success("Livro atualizado com sucesso!");
            handleBack();
        } catch (error: any) {
            toast.error(`Erro: ${error.message}`);
        }
    });

    const handleBack = () => {
        navigate(routes.books);
        dispatch(resetBookData());
    }
        
    return (
        <form onSubmit={onSubmit} noValidate>
            <Card size="1">
                <Flex direction="column" gap="4">
                    <TextFieldComponent
                        name="title"
                        label="Título"
                        control={control}
                        errors={errors}
                        fieldProps={{ placeholder: "Título do Livro" }}
                        required={true}
                    />
                      <TextFieldComponent
                        name="copies"
                        label="Cópias"
                        control={control}
                        errors={errors}
                        fieldProps={{ placeholder: "Cópias do Livro" }}
                        required={true}
                    />
                    <SelectComponent name="idCategory" label="Categoria" control={control} errors={errors} style={{ width: '100%' }}
                        options={data?.items.map(category => {
                            return {
                                label: category.description,
                                value: category.id ?? ""
                            }
                        })}
                        itemsLoading={isLoading}
                        itemsError={isError}
                        required={true}
                    />
                    <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
                        <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
                            <ChevronLeftIcon /> Voltar
                        </Button>
                        <Button type="submit" disabled={mutation.isLoading}>
                            {mutation.isLoading ? <Spinner loading /> : <EnterIcon />}
                            Guardar
                        </Button>
                    </Flex>
                </Flex>
            </Card>
        </form>
    );
};
